export default "__VITE_ASSET__DbIrztfg__"